export default "__VITE_ASSET__82d3a914__"